<div class="inicio">

    <p class="titulo">SOLICITUDES REALIZADAS     <!---->
      <mat-icon color="primary" matTooltip="Click para más información" (click)="botonInformacion()" >info</mat-icon>
    </p>
   <div class="div">
      <mat-tab-group   (selectedIndexChange)="llenarTabla($event)">
        <!--SOLICITUDES PENDIENTES-->
          <mat-tab label="PENDIENTES" >
            <div>
                  <!--Boton Descargar reporte--
              <div class="grid-container5">
                <button mat-raised-button color="primary"> REPORTE
                    <mat-icon> file_download </mat-icon>
                </button>&nbsp;
              </div>-->
              <div class="grid-container2">
                <mat-form-field>
                  <mat-label>BUSCAR</mat-label>
                  <input matInput [(ngModel)]="datoBuscar" [ngModelOptions]="{standalone: true}" (keyup)="applyFilterE($event)"  placeholder="INGRESE DATO A BUSCAR">
                </mat-form-field>
              </div>
              <!--TABLA-->
              <mat-progress-bar *ngIf="expression" mode="indeterminate"></mat-progress-bar>
              <table mat-table [dataSource] = "dataSourceE"  class="mat-elevation-z8">
                  <ng-container matColumnDef="opciones">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                      <td mat-cell *matCellDef="let element">
                          <button mat-mini-fab style="background-color: #2ae904;" (click)="detalleSolicitud(element.id_solicitud)"> <span class="material-icons">visibility</span> </button>
                          <button mat-mini-fab style="background-color: #fa2424;" (click)="cancelarSolicitud(element.id_solicitud)" > <mat-icon>cancel</mat-icon> </button>
                      </td>
                  </ng-container>
                  <ng-container  matColumnDef="nomColaborador">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                      <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nomPuesto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                  </ng-container>
                  <ng-container matColumnDef="name_tipo_solicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.name_tipo_solicitud}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nomSolicitante">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                  </ng-container>
                  <ng-container matColumnDef="fechaSolicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.fechaSolicitud}} </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

              </table>
              <mat-paginator #paginatorE class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
            </div>
          </mat-tab>

          <!--SOLICITUDES ATENDIDAS-->
          <mat-tab label="ATENDIDOS" >
            <div >
              <div class="grid-container2" >
                <mat-form-field>
                  <mat-label>BUSCAR</mat-label>
                  <input matInput [(ngModel)]="datoBuscar2" [ngModelOptions]="{standalone: true}" (keyup)="applyFilterA($event)"  placeholder="INGRESE DATO A BUSCAR">
                </mat-form-field>
              </div>

              <!--TABLA-->
              <mat-progress-bar *ngIf="expression2" mode="indeterminate"></mat-progress-bar>

              <table mat-table [dataSource] = "dataSourceA"  class="mat-elevation-z8">
                  <ng-container matColumnDef="opciones">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                      <td mat-cell *matCellDef="let element">
                          <button mat-mini-fab style="background-color: #2ae904;" (click)="detalleSolicitud(element.id_solicitud)"> <span class="material-icons">visibility</span> </button>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="nomColaborador">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                      <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nomPuesto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                  </ng-container>
                  <ng-container matColumnDef="name_tipo_solicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.name_tipo_solicitud}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nomSolicitante">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                  </ng-container>
                  <ng-container matColumnDef="fechaSolicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.fechaSolicitud}} </td>
                  </ng-container>
                  <ng-container matColumnDef="fechaModificacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{this.nomEncabezadoFecha}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.fechaModificacion}} </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="encabezadostablaAten"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostablaAten"></tr>

              </table>
              <mat-paginator #paginatorA class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
            </div>
          </mat-tab>

          <!--SOLICITUDES CANCELADAS-->
          <mat-tab label="CANCELADOS">
            <div>
              <div class="grid-container2" >
                <mat-form-field>
                  <mat-label>BUSCAR</mat-label>
                  <input matInput [(ngModel)]="datoBuscar3" [ngModelOptions]="{standalone: true}" (keyup)="applyFilterC($event)"  placeholder="INGRESE DATO A BUSCAR">
                </mat-form-field>
              </div>

              <!--TABLA-->
              <mat-progress-bar *ngIf="expression3" mode="indeterminate"></mat-progress-bar>

              <table mat-table [dataSource] = "dataSourceC"  class="mat-elevation-z8">
                  <ng-container matColumnDef="opciones">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                      <td mat-cell *matCellDef="let element">
                          <button mat-mini-fab style="background-color: #2ae904;" (click)="detalleSolicitud(element.id_solicitud)"> <span class="material-icons">visibility</span> </button>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="nomColaborador">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                      <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nomPuesto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
                  </ng-container>
                  <ng-container matColumnDef="name_tipo_solicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.name_tipo_solicitud}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nomSolicitante">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                  </ng-container>
                  <ng-container matColumnDef="fechaSolicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.fechaSolicitud}} </td>
                  </ng-container>
                  <ng-container matColumnDef="fechaModificacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{this.nomEncabezadoFecha}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.fechaModificacion}} </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="encabezadostablaAten"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostablaAten;"></tr>

              </table>
              <mat-paginator #paginatorC class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
            </div>
          </mat-tab>
      </mat-tab-group>
  </div>
</div>
